import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Snackbar from '@material-ui/core/Snackbar'
import { hideAppSnackbar } from './actions'

const mapStateToProps = ({ appSnackbar }) => appSnackbar

const mapDispatchToProps = {
  hideAppSnackbarAction: hideAppSnackbar
}

const AppSnackbar = ({ message, isOpen, hideAppSnackbarAction }) => (
  <Snackbar
    open={isOpen}
    message={message}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    onClose={hideAppSnackbarAction}
  />
)

AppSnackbar.propTypes = {
  hideAppSnackbarAction: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.any,
}

export default connect(mapStateToProps, mapDispatchToProps)(AppSnackbar)
